import axios, { AxiosResponse } from 'axios';

import apiPaths from 'enums/apiPaths';

// Post metoda pro volani obnovy hesla, ktera nam vraci
const restoreApi = async (email: string, lang: string, captid: string | number, captcha: string) => {
    const { data }: AxiosResponse = await axios({
        method: 'POST',
        url: apiPaths.RESTORE,
        data: {
            email,
            lang,
            captid: captid,
            value: captcha
        }
    });
    return data;
};

export default restoreApi;
